"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getColor = exports.mergeGeoJson = exports.extend = exports.colors = exports.generateRandomString = exports.rand = exports.generateRandomColor = exports.getTime = exports.shuffle = void 0;
const getTime = () => {
    const date = new Date();
    return date.getTime();
};
exports.getTime = getTime;
const generateRandomColor = () => {
    let letters = "0123456789ABCDEF";
    let color = "#";
    for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
};
exports.generateRandomColor = generateRandomColor;
// random number generator
function rand(frm, to) {
    return ~~(Math.random() * (to - frm)) + frm;
}
exports.rand = rand;
const generateRandomString = (length = 6) => Math.random().toString(20).substring(2, length);
exports.generateRandomString = generateRandomString;
function shuffle(a) {
    for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
}
exports.shuffle = shuffle;
const colors = [
    "#0154A4",
    "#3276B5",
    "#86ACD3",
    "#6B439C",
    "#8869AD",
    "#B7A5CD",
    "#A64499",
    "#BB6AAF",
    "#D3A4CE",
    "#E44097",
    "#E966AC",
    "#F1A3CD",
    "#ED1B24",
    "#F04951",
    "#F69195",
    "#F37020",
    "#F58D4E",
    "#F9BB94",
    "#F78F1E",
    "#FBA64C",
    "#FBC994",
    "#00A88F",
    "#33B8A5",
    "#84D4C9",
];
exports.colors = colors;
const mergeGeoJson = (object1, object2) => {
    const returnObj = JSON.parse(JSON.stringify(object1));
    returnObj.features.forEach((location) => {
        object2.forEach((el) => {
            if (el.properties.abbreviation === location.properties.abbreviation) {
                location.properties = Object.assign(Object.assign({}, el.properties), location.properties);
            }
        });
    });
    return returnObj;
};
exports.mergeGeoJson = mergeGeoJson;
const extend = function (deep = false, ...args) {
    // Variables
    let extended = {};
    let i = 0;
    let length = args.length;
    // Merge the object into the extended object
    const merge = function (obj) {
        for (let prop in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, prop)) {
                // If deep merge and property is an object, merge properties
                if (deep && Object.prototype.toString.call(obj[prop]) === "[object Object]") {
                    extended[prop] = extend(true, extended[prop], obj[prop]);
                }
                else {
                    extended[prop] = obj[prop];
                }
            }
        }
    };
    // Loop through each object and conduct a merge
    for (; i < length; i++) {
        let item = args[i];
        merge(item);
    }
    return extended;
};
exports.extend = extend;
function getColor(d) {
    if (d == 12)
        return "#2f4f4f";
    if (d == 11)
        return "#a0522d";
    if (d == 10)
        return "#008000";
    if (d == 9)
        return "#4b0082";
    if (d == 8)
        return "#ff0000";
    if (d == 7)
        return "#ffff54";
    if (d == 6)
        return "#90ee90";
    if (d == 5)
        return "#00ffff";
    if (d == 4)
        return "#ff00ff";
    if (d == 3)
        return "#6495ed";
    if (d == 2)
        return "#0000cd";
    if (d == 1)
        return "#ff69b4";
    else
        return "#a9a9a9";
}
exports.getColor = getColor;
